import { Metamodel } from 'shell-models-lib';
import { DataFlowDatasetSettings, DatasetFormatType } from './dataflow-dataset-settings';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowSink } from '../dataflow-sink';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.adobePrivacy.dataflowSettings
})
export class AdobePrivacySettings extends DataFlowDatasetSettings {
    @Metamodel.attribute({
    })
    public namespace: DataFlowExpression;

    @Metamodel.attribute({
    })
    public namespaceQualifier: DataFlowExpression;

    @Metamodel.attribute({
    })
    public requestInterval: DataFlowExpression;

    public get transform(): DataFlowSink {
        return this.owner as DataFlowSink;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.AdobePrivacy;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-adobe-integration';
    }

    public initialize(subFormat: string): void {
        this.namespace = this.transform.createTemplatableExpression();
        this.namespaceQualifier = this.transform.createTemplatableExpression();
        this.requestInterval = this.transform.createTemplatableExpression();
    }
}
